import { useQuery } from '@tanstack/react-query';
import type { PharmacyT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchPharmacyById } from '../api/getPharmacyById.js';
import { rxKeys } from './keys.js';

export function pharmacyByIdQueryDefinition(pharmacyId: string) {
  return {
    queryKey: rxKeys.pharmacyById(pharmacyId),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchPharmacyById(pharmacyId, signal),
    meta: {
      toast: {
        title: 'Could not load pharmacy',
        description: 'Pharmacy could not be fetched from DoseSpot.',
      },
    },
  } as const;
}

export function usePharmacyByIdQuery(pharmacyId: string | undefined) {
  const enabled = Boolean(pharmacyId && pharmacyId.trim() !== '');

  return useQuery({
    queryKey: pharmacyId ? rxKeys.pharmacyById(pharmacyId) : (['rx', 'pharmacy', ''] as const),
    queryFn: ({ signal }: { signal?: AbortSignal }): Promise<PharmacyT> => {
      if (!pharmacyId) {
        throw new Error('Missing pharmacyId');
      }
      return fetchPharmacyById(pharmacyId, signal);
    },
    enabled,
  });
}
